module.exports = __webpack_public_path__ + "img/public_dropdown_up_grey.cdfcf2fb.svg";